export default "__VITE_ASSET__cb915992__"